
<ng-template ssMobileToolbarContent>
    <div class="flex-1 flex-row flex--align-center gap-small">
        <button mat-icon-button (click)="back()"><mat-icon class="primary-contrast-text">arrow_back</mat-icon></button>
        <h4 class="mat-headline-5 margin-none primary-contrast-text">{{ titleObs | async | translate}}</h4>
    </div>

</ng-template>

<mat-card class="padding-none full-stretch">

    <mat-card-header *ngIf="!(isSmallerScreenObs | async)"  #header class="border-primary-bottom padding-standard flex-row flex--justify-between flex--align-center">
        <mat-card-title class="mat-headline-4 margin-none">
            {{ titleObs | async | translate}}
            <span class="primary-text-900">{{(userDisplayObs | async)}}</span>
        </mat-card-title>
        <button mat-icon-button (click)="back()"><mat-icon>close</mat-icon></button>
    </mat-card-header>


    <mat-card-content class="full-stretch overflow-auto padding-none">

        <mat-tab-group
            [mat-stretch-tabs]="true"
            (selectedIndexChange)="showSecondTab($event)"
            class="full-height"
            [applyClassOnChild]="{
                'mat-tab-header':['primary-background-A400-transparent'],
                '.mdc-tab__text-label':['mat-headline-6']
            }"
        >

            <mat-tab [label]="'ss-entities.user.detail' | translate">

                <div [ngClass]="{
                        'padding-standard':!(isSmallerScreenObs | async),
                        'full-stretch':isSmallerScreenObs | async
                    }"
                >
                    <mat-card
                        [ngClass]="{
                            'full-stretch':isSmallerScreenObs | async,
                            'border-style-none':isSmallerScreenObs | async
                        }"
                        appearance="outlined"
                        class="col-width-2--fixed max-full-width"
                    >

                        <mat-card-content  fixedScroll [baseElement]="baseElement" [disable]="!(isSmallerScreenObs | async)" [otherElements]="append(footer)" class="position-relative">

                                <ss-core-loader-outlet height="100%" [keys]="['user.insert','user.update','user.remove','user.load']"></ss-core-loader-outlet>
                                <ss-dynamic-form    [controls]="controls"
                                                    [formData]="userSubject | async"
                                                    [colCount]="colCountObs | async"
                                                    (mainFormGroupSubject)="mainFormGroupSubject.next($event)"
                                ></ss-dynamic-form>

                        </mat-card-content>

                        <mat-card-footer #footer class="padding-standard border-gray-top flex-row-reverse">

                            <button     libLoaderButton
                                        [keys]="['user.insert','user.update']"
                                        (click)="save()"
                                        [ngClass]="{'flex-1':isSmallerScreenObs | async}"
                                        mat-raised-button
                                        color="accent"
                                        *ngIf="isDesignerLoginUserPassword"
                            >
                                {{'ss-general.save' | translate}}
                            </button>
                        </mat-card-footer>
                    </mat-card>
                </div>
            </mat-tab>

            <mat-tab [label]="'ss-entities.user.configuration' | translate" [disabled]="!(userIdSubject | async)">


                <ss-user-splug-config *ngIf="showSecondTabSubject | async"></ss-user-splug-config>

            </mat-tab>
        </mat-tab-group>

    </mat-card-content>


</mat-card>

